/* eslint-disable import/prefer-default-export */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */

import SellerHome from "components/pages/seller/home/SellerHome";

import SearchOrderList from "components/pages/seller/orders/SearchOrderList";
import Orders from "components/pages/seller/orders/Orders";

import PrivateProducts from "components/pages/seller/products/PrivateProducts";
import PrivateCategories from "components/pages/seller/products/PrivateCategories";
import PrivateProductsByCategory from "components/pages/seller/products/PrivateProductsByCategory";
import BrandedProductsMain from "components/pages/seller/products/BrandedProductsMain";
import BrandedProductCatalog from "components/pages/seller/products/BrandedProductCatalog";
import BrandedProductByCategory from "components/pages/seller/products/BrandedProductByCategory";
import BrandedBarCodeScannerList from "components/pages/seller/products/BrandedBarCodeScannerList";
import SearchProductList from "components/pages/seller/products/SearchProductList";

import StoreHome from "components/pages/seller/register-store/Home";
import ClaimStore from "components/pages/seller/register-store/ClaimStore";

import StoreProfileHome from "components/pages/seller/store/StoreProfileHome";
import StoreProfileName from "components/pages/seller/store/StoreProfileName";
import StoreProfileLogo from "components/pages/seller/store/StoreProfileLogo";
import StoreProfileAddress from "components/pages/seller/store/StoreProfileAddress";
import StoreProfileSocial from "components/pages/seller/store/StoreProfileSocial";
import StoreProfileDomain from "components/pages/seller/store/StoreProfileDomain";
import StoreProfileImages from "components/pages/seller/store/StoreProfileImages";
import StoreProfileService from "components/pages/seller/store/StoreProfileService";
import StoreProfilePayment from "components/pages/seller/store/StoreProfilePayment";
import StorePaymentQRCode from "components/pages/seller/store/StorePaymentQRCode";
import StoreProfileTax from "components/pages/seller/store/StoreProfileTax";

import SellerOffersMain from "components/pages/seller/offers-coupons/SellerOffersMain";
import StoreProfileReturns from "components/pages/seller/store/StoreProfileReturns";

import SubscriptionHome from "components/pages/seller/subscriptions/Home";
import SubscriptionStore from "components/pages/seller/subscriptions/SubscriptionStore";
import SubscriptionCheckout from "components/pages/seller/subscriptions/SubscriptionCheckout";
import SubscriptionPaymentCheckout from "components/pages/seller/subscriptions/SubscriptionCheckout/payment-page";
import SubscriptionOrderSuccess from "components/pages/seller/subscriptions/SubscriptionCheckout/success-page";
import UserProductsPageTrack from "../components/pages/user/products/UserProductsPageTrack";
import UserProductPageDetail from "../components/pages/user/products/UserProductPageDetail";

import WholeSaleMain from "components/pages/seller/wholesale/WholeSaleMain";

import WholesaleShopSiteHomeMain from "components/pages/seller/wholesale/WholesaleShopSiteHomeMain";
import WholesaleShopProductPageSearch from "components/pages/seller/wholesale/WholesaleShopProductPageSearch";
import WholesaleShopProductPageDetail from "components/pages/seller/wholesale/WholesaleShopProductPageDetail";
import WholesaleShopCart from "components/pages/seller/wholesale/WholesaleShopCart";

import WholesaleShopCheckOut from "components/pages/seller/wholesale/WholesaleShopCheckOut";
import WholesaleShopPaymentCheckout from "components/pages/seller/wholesale/WholesaleShopPaymentCheckout";
import WholesaleShopOrderSuccess from "components/pages/seller/wholesale/WholesaleShopOrderSuccess";

import WholesaleShopOrderList from "components/pages/seller/wholesale/WholesaleShopOrderList";
import WholesaleShopOrderDetail from "components/pages/seller/wholesale/WholesaleShopOrderDetail";

import WholesaleUserOrderList from "components/pages/seller/wholesale/WholesaleUserOrderList";
import WholesaleUserOrderDetail from "components/pages/seller/wholesale/WholesaleUserOrderDetail";

import StoreAppointments from "components/pages/seller/StoreAppointments";
import AppointmentSettings from "components/pages/seller/AppointmentSettings";

import SellerContacts from "components/pages/seller/Contacts";


export const SellerAppRoutes = [
  { path: "/", component: SellerHome, exact: true },

  // Orders
  { path: "/myorders", component: Orders, exact: true },
  { path: "/myorders/search", component: SearchOrderList, exact: true },

  // Products
  { path: "/myproducts/all", component: BrandedProductsMain, exact: true },
  { path: "/myproducts/private", component: PrivateProducts, exact: true },
  { path: "/myproducts/categories", component: PrivateCategories, exact: true },
  { path: "/myproducts/category/:categoryId", component: PrivateProductsByCategory, exact: true },
  { path: "/myproducts/scan", component: BrandedBarCodeScannerList, exact: true },
  { path: "/myproducts/search", component: SearchProductList, exact: true },
  { path: "/brandedproducts/catalog", component: BrandedProductCatalog, exact: true },
  { path: "/brandedproducts/category/:categoryId", component: BrandedProductByCategory, exact: true },
  { path: "/brandedproducts/:storeId/category/:categoryId", component: BrandedProductByCategory, exact: true },

  // Register
  { path: "/register-store", component: StoreHome, exact: true },
  { path: "/register-store/claim/:storeId", component: ClaimStore, exact: true },

  // Shop profile
  { path: "/myshop", component: StoreProfileHome, exact: true },
  { path: "/myshop/logo", component: StoreProfileLogo, exact: true },
  { path: "/myshop/profile", component: StoreProfileName, exact: true },
  { path: "/myshop/address", component: StoreProfileAddress, exact: true },
  { path: "/myshop/social", component: StoreProfileSocial, exact: true },
  { path: "/myshop/domain", component: StoreProfileDomain, exact: true },
  { path: "/myshop/photos", component: StoreProfileImages, exact: true },
  { path: "/myshop/service", component: StoreProfileService, exact: true },
  { path: "/myshop/payment", component: StoreProfilePayment, exact: true },
  { path: "/myshop/qrcode", component: StorePaymentQRCode, exact: true },
  { path: "/myshop/tax", component: StoreProfileTax, exact: true },
  { path: "/myshop/offers", component: SellerOffersMain, exact: true },
  { path: "/myshop/returns", component: StoreProfileReturns, exact: true },
  { path: "/myshop/appointments", component: StoreAppointments, exact: true },
  { path: "/myshop/appointment-settings", component: AppointmentSettings, exact: true },
  { path: "/myshop/contacts", component: SellerContacts, exact: true },

  // Subscription
  { path: "/subscriptions", component: SubscriptionHome, exact: true },
  { path: "/subscriptions/store", component: SubscriptionStore, exact: true },
  { path: "/subscriptions/checkout", component: SubscriptionCheckout, exact: true },
  { path: "/subscriptions/payment-page", component: SubscriptionPaymentCheckout, exact: true },
  { path: "/subscriptions/order-success", component: SubscriptionOrderSuccess, exact: true },

    // Wholesale routes
  { path: "/products", component: WholeSaleMain, exact: true },
  { path: "/products/sort/:sort", component: WholeSaleMain, exact: true },
  { path: "/products/category/:category", component: WholeSaleMain, exact: true },
  { path: "/products/search", component: WholeSaleMain, exact: true },
  { path: "/products/search/:query", component: WholeSaleMain, exact: true },

  { path: "/orders", component: WholeSaleMain, exact: true },
  { path: "/orders/:orderId", component: WholesaleUserOrderDetail, exact: true },

  { path: "/products/show", component: UserProductsPageTrack, exact: true },
  { path: "/products/show/:type", component: UserProductsPageTrack, exact: true },

  { path: "/products/:id", component: UserProductPageDetail, exact: true },

  { path: "/shops", component: WholeSaleMain, exact: true },
  { path: "/shops/sort/:sort", component: WholeSaleMain, exact: true },
  { path: "/shops/search", component: WholeSaleMain, exact: true },
  { path: "/shops/search/:query", component: WholeSaleMain, exact: true },

  { path: "/shops/show", component: WholeSaleMain, exact: true },
  { path: "/shops/show/:type", component: WholeSaleMain, exact: true },

  { path: "/shop/:shopId", component: WholesaleShopSiteHomeMain, exact: true },

  // shop products page
  { path: "/shop/:shopId/products", component: WholesaleShopProductPageSearch, exact: true },
  { path: "/shop/:shopId/products/sort/:sort", component: WholesaleShopProductPageSearch, exact: true },
  { path: "/shop/:shopId/products/search", component: WholesaleShopProductPageSearch, exact: true },
  { path: "/shop/:shopId/products/search/:query", component: WholesaleShopProductPageSearch, exact: true },
  { path: "/shop/:shopId/products/:prodId", component: WholesaleShopProductPageDetail, exact: true },

  // Checkout - common component with seller shop
  { path: "/shop/:shopId/cart", component: WholesaleShopCart, exact: true },
  { path: "/shop/:shopId/cart/checkout", component: WholesaleShopCheckOut, exact: true },

  { path: "/shop/:shopId/cart/payment-page", component: WholesaleShopPaymentCheckout, exact: true },
  { path: "/shop/:shopId/cart/order-success", component: WholesaleShopOrderSuccess, exact: true },

  // Orders - common component with seller shop
  { path: "/shop/:shopId/orders", component: WholesaleShopOrderList, exact: true },
  { path: "/shop/:shopId/orders/:orderId", component: WholesaleShopOrderDetail, exact: true },


];
